import {SpecialRequest} from '../../special-request/special-request.model';
import {WarrantyStatus} from '../../models/warranty-status';

export class MessagesUtil {
  static selectSpecialRequestsNotBeingReviewed(specialRequests: Array<SpecialRequest>): Array<SpecialRequest> {
    return specialRequests?.filter(
      (val) => val.warrantyStatus !== WarrantyStatus.IN_REVIEW && val.warrantyStatus !== WarrantyStatus.IN_DEALER_CORRECTION
    );
  }
}
